<template>
  <div class="salesforce-container">
    <v-card flat class="futuristic-card">
      <div class="card-header">
        <h1 class="text-md-center earth-color">SALESFORCE INTEGRATION</h1>
        <div class="title-decoration"></div>
      </div>
      <v-layout row wrap>
        <v-flex lg6 md6 sm12 xs12>
          <v-container>
            <v-tabs
              color="#587e27"
              slider-color="#587e27"
              class="futuristic-tabs"
            >
              <v-tab key="login" ripple class="tab-label">
                <span class="tab-text">LOGIN</span>
              </v-tab>
              <v-tab key="integrate" ripple class="tab-label">
                <span class="tab-text">INTEGRATION</span>
              </v-tab>
              <v-tab-item key="login">
                <v-flex>
                  <v-card flat class="inner-card">
                    <v-container>
                      <h3 class="earth-color">SALESFORCE LOGIN</h3>
                      <br>
                      <p class="info-text">A new browser tab will be opened for authentication.</p>
                      <br>
                      <a class="futuristic-btn primary-btn btn-block" target="_blank" href="https://bookings.olpejetaconservancy.org:5005/salesforce/authenticate">
                        <v-icon left>login</v-icon>
                        LOGIN TO SALESFORCE
                      </a>
                      <br>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-tab-item>
              <v-tab-item key="integrate">
                <v-flex>
                  <v-card flat class="inner-card">
                    <v-container>
                      <h3 class="earth-color">SALESFORCE INTEGRATION</h3>
                      <br>
                      <p class="info-text">Select the record types to post:</p>
                      <div class="checkbox-group">
                        <v-checkbox
                          v-model="salesforce_publish.bookings"
                          color="#587e27"
                          :label="'Bookings'"
                          class="futuristic-checkbox"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="salesforce_publish.donations"
                          color="#2196f3"
                          :label="'Donations'"
                          class="futuristic-checkbox"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="salesforce_publish.memberships"
                          color="#ff5252"
                          :label="'Memberships'"
                          class="futuristic-checkbox"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="salesforce_publish.volunteer_data"
                          color="#9c27b0"
                          :label="'Volunteer Data'"
                          class="futuristic-checkbox"
                        ></v-checkbox>
                      </div>
                      <br>
                      <v-btn 
                        depressed 
                        block 
                        @click="triggerSalesforcePush" 
                        :loading="this.$store.state.LoadingStore.loading"
                        class="futuristic-btn primary-btn"
                      >
                        <v-icon left>cloud_upload</v-icon>
                        POST TO SALESFORCE
                      </v-btn>
                      <br>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-tab-item>
            </v-tabs>
          </v-container>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'SalesForce',
  data () {
    return {
      update: false,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      salesforce: {
        password: '',
        email: ''
      },
      salesforce_publish: {
        memberships: true,
        bookings: true,
        donations: true,
        volunteer_data: true
      },
      columns: [
        {
          text: 'Email',
          name: 'details_email'
        },
        {
          text: 'Status',
          name: 'status'
        },
        {
          text: 'Validity',
          name: 'valid_credentials'
        }
      ]
    }
  },
  created () {
    this.$store.dispatch('get_all_credentials')
  },
  methods: {
    postUserType: function () {
      this.$store.dispatch('loading_true')
      this.$store.dispatch('post_credential', this.salesforce)
    },
    triggerSalesforcePush: function () {
      var data = {
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  }
}
</script>

<style scoped>
.salesforce-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.salesforce-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-tabs {
  background: #f9f9f9;
}

.tab-label {
  font-weight: 600;
}

.tab-text {
  color: #f0f3f0 !important;
}

.inner-card {
  padding: 16px;
}

.info-text {
  font-size: 16px;
  color: #616161;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
  padding: 16px;
  height: auto;
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

.futuristic-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.primary-btn {
  background: linear-gradient(45deg, #587e27, #4caf50) !important;
  color: white !important;
}

.btn-block {
  display: block;
  width: 100%;
}

.checkbox-group {
  padding: 8px 0;
}

.futuristic-checkbox >>> .v-icon {
  color: inherit !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .salesforce-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.75rem;
  }
}

@media (max-width: 600px) {
  .salesforce-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.5rem;
  }
  
  .futuristic-btn {
    padding: 12px;
  }
}
</style>

<style>
/* Global tab styling */
.futuristic-tabs .v-tabs__bar {
  background-color: #f5f7fa;
}

.futuristic-tabs .v-tabs__item {
  color: #587e27 !important;
  font-weight: 600;
}

.futuristic-tabs .v-tabs__item--active {
  color: #587e27 !important;
  background-color: rgba(46, 125, 50, 0.1);
}

.futuristic-tabs .v-tabs__slider {
  background-color: #587e27;
}
</style>